module.exports = __webpack_public_path__ + "img/qatar.cac0f09e.jpg";